// extracted by mini-css-extract-plugin
export var socialManager = "bz_fd";